module.exports = __webpack_public_path__ + "static/media/mic_2.72ed5097.jpg";